{
  "header": {
    "title": "Sessieplanning",
    "description": "Start en stop laadsessies op je stations automatisch op vaste tijden."
  },
  "noAccess": {
    "title": "Geen toegang",
    "description": "We konden je account niet laden. Probeer het zo weer."
  },
  "table": {
    "title": "Planningen",
    "count": "{{count}} planningen",
    "count_one": "{{count}} planning",
    "count_other": "{{count}} planningen",
    "searchPlaceholder": "Planningen zoeken",
    "searchAria": "Planningen op naam zoeken",
    "stationCount": "{{count}} stations",
    "stationCount_one": "{{count}} station",
    "stationCount_other": "{{count}} stations",
    "evse": "Connector {{evse}}",
    "columns": {
      "name": "Planning",
      "owner": "Eigenaar",
      "stations": "Stations",
      "period": "Periode",
      "schedule": "Tijden",
      "lastRun": "Laatste run",
      "status": "Status"
    },
    "empty": {
      "title": "Nog geen planningen",
      "description": "Maak een planning om sessies op je stations automatisch te starten en te stoppen."
    },
    "error": {
      "title": "Planningen laden mislukt",
      "description": "Er ging iets mis. Probeer het zo weer."
    }
  },
  "action": {
    "Start": "Start",
    "Stop": "Stop"
  },
  "status": {
    "active": "Actief",
    "inactive": "Inactief"
  },
  "execStatus": {
    "Running": "Bezig",
    "Success": "Geslaagd",
    "Partial": "Deels mislukt",
    "Failed": "Mislukt"
  },
  "period": {
    "between": "{{start}} t/m {{end}}",
    "from": "Vanaf {{start}}",
    "until": "Tot en met {{end}}",
    "always": "Geen datumgrenzen"
  },
  "weekdays": {
    "short": {
      "0": "Zo",
      "1": "Ma",
      "2": "Di",
      "3": "Wo",
      "4": "Do",
      "5": "Vr",
      "6": "Za"
    }
  },
  "lastRun": {
    "never": "Nog niet uitgevoerd"
  },
  "owner": {
    "tenant": "Tenant",
    "organisation": "Organisatie",
    "wholeFleet": "Hele vloot",
    "wholeFleetHint": "Elk station"
  },
  "actions": {
    "new": "Nieuwe planning",
    "edit": "Bewerken",
    "delete": "Verwijderen",
    "cancel": "Annuleren",
    "save": "Opslaan",
    "enable": "Inschakelen",
    "disable": "Uitschakelen",
    "history": "Rungeschiedenis"
  },
  "form": {
    "addTitle": "Nieuwe planning",
    "editTitle": "Planning bewerken",
    "description": "Kies de stations, de periode en de tijden waarop een sessie moet starten en stoppen. Tijden zijn Nederlandse tijd (Europe/Amsterdam).",
    "fields": {
      "name": "Naam",
      "station": "Laadstation",
      "evse": "Connector",
      "periodStart": "Eerste dag",
      "periodEnd": "Laatste dag",
      "action": "Actie",
      "time": "Tijd",
      "recipients": "Ontvangers rapport",
      "active": "Actief"
    },
    "placeholders": {
      "name": "bijv. Leiden winter 2027",
      "stationSearch": "Zoek een station op id, naam of locatie en kies het om toe te voegen",
      "recipients": "naam@voorbeeld.nl, ops@voorbeeld.nl"
    },
    "sections": {
      "stations": "Laadstations",
      "period": "Periode",
      "rules": "Start- en stoptijden"
    },
    "stations": {
      "loading": "Je stations worden geladen...",
      "error": "Je stations konden niet worden geladen. Probeer het zo weer.",
      "noResults": "Geen laadstation gevonden. Alleen stations uit de lijst kunnen worden ingepland.",
      "selected": "{{count}} stations geselecteerd",
      "selected_one": "{{count}} station geselecteerd",
      "selected_other": "{{count}} stations geselecteerd",
      "remove": "Station verwijderen"
    },
    "rules": {
      "add": "Tijd toevoegen",
      "remove": "Tijd verwijderen"
    },
    "hints": {
      "evse": "Het connectornummer op elk station (1 bij stations met een connector).",
      "period": "Beide datums tellen mee. Laat een datum leeg voor geen grens.",
      "rules": "Elke regel loopt op elke aangevinkte dag. Voeg een regel toe per start en per stop.",
      "recipients": "Optioneel. Kommagescheiden e-mailadressen die na elke run een rapport ontvangen.",
      "active": "Een actieve planning loopt op haar tijden. Zet haar uit om te pauzeren zonder te verwijderen."
    },
    "errors": {
      "name": "Vul een naam in.",
      "stations": "Selecteer minstens een laadstation (maximaal 100).",
      "evse": "Vul een connectornummer van 1 of hoger in.",
      "period": "De laatste dag ligt voor de eerste dag.",
      "rules": "Voeg minstens een tijd toe, elk met een geldige tijd en minstens een weekdag.",
      "recipients": "Vul geldige e-mailadressen in, of laat het veld leeg."
    }
  },
  "deleteDialog": {
    "title": "Planning verwijderen?",
    "description": "\"{{name}}\" en de rungeschiedenis verwijderen? Dit kan niet ongedaan worden gemaakt.",
    "confirm": "Verwijderen"
  },
  "executions": {
    "title": "Rungeschiedenis",
    "counts": "{{ok}} ok, {{skipped}} overgeslagen, {{failed}} mislukt",
    "empty": {
      "title": "Nog geen runs",
      "description": "Deze planning is nog niet uitgevoerd."
    },
    "columns": {
      "when": "Gepland op",
      "action": "Actie",
      "status": "Resultaat",
      "stations": "Stations",
      "summary": "Details"
    },
    "error": {
      "title": "Geschiedenis laden mislukt",
      "description": "Er ging iets mis. Probeer het zo weer."
    }
  },
  "toasts": {
    "saved": "Planning opgeslagen.",
    "saveFailed": "Planning opslaan mislukt.",
    "deleted": "Planning verwijderd.",
    "deleteFailed": "Planning verwijderen mislukt.",
    "toggled": "Planning bijgewerkt.",
    "toggleFailed": "Planning bijwerken mislukt."
  }
}
